module.exports = __webpack_public_path__ + "img/footer.f1f6a62e.png";